const HOURS_THRESHOLD_FOR_DAYS = 22;
const MINUTES_THRESHOLD_FOR_HOURS = 45;

export const getRelativeTimeUntil = (locale: string, date: Date) => {
  const targetDate = new Date(date);
  const diffInMs = targetDate.getTime() - Date.now();

  if (diffInMs < 0) {
    return '';
  }

  const rtf = new Intl.RelativeTimeFormat(locale, {
    numeric: 'auto',
    style: 'long',
    localeMatcher: 'best fit',
  });

  const diffInMinutes = diffInMs / (1000 * 60);
  const diffInHours = diffInMinutes / 60;
  const diffInDays = diffInHours / 24;

  if (diffInHours >= HOURS_THRESHOLD_FOR_DAYS) {
    return rtf.format(Math.round(diffInDays), 'day');
  } else if (diffInMinutes >= MINUTES_THRESHOLD_FOR_HOURS) {
    return rtf.format(Math.round(diffInHours), 'hour');
  } else {
    return rtf.format(Math.round(diffInMinutes), 'minute');
  }
};
